import type { Swiper } from 'swiper';

export function getVisibleSlideIndexes(swiper: Swiper): number[] {
  return swiper.slides.reduce<number[]>((acc, slide, i) => {
    if (slide.classList.contains('swiper-slide-visible')) acc.push(i);
    return acc;
  }, []);
}
